import { gql, TypedDocumentNode } from '@apollo/client';
import { PaymentSource } from '../../../constants';
import { OrderSummary, ORDER_SUMMARY_FRAGMENT } from '../../useOrderSummary';

export type PlaceAffirmOrderMutationInput = {
  data: {
    type: 'orders';
    attributes: {
      address_id: number;
      cart_id: string;
      country_code: string;
      offer_code: string | null;
      payment_source: PaymentSource.BraintreeAffirm;
      shipment_method: number;
      ga4_client_id?: string;
      ga4_session_id?: number;
      ga4_session_number?: number;
      payment_summary: {
        encrypted_card_data: {
          encrypted_data: string;
        };
        affirm_checkout_token: string;
        billing_address: {
          address_line1: string;
          address_line2: string;
          city: string;
          state: string;
          country_code: string;
          postal_code: string;
        };
      };
    };
  };
};

export type PlaceAffirmOrderMutationVariables = {
  input: PlaceAffirmOrderMutationInput;
};

export type Order = {
  __typename: 'RestOrder';
  attributes: {
    __typename: 'RestOrderAttributes';
    orderNumber: string;
  };
};

export type PlaceAffirmOrderMutation = {
  checkout: {
    data: OrderSummary[];
  };
};

export const PLACE_AFFIRM_ORDER_MUTATION: TypedDocumentNode<
  PlaceAffirmOrderMutation,
  PlaceAffirmOrderMutationVariables
> = gql`
  mutation PlaceAffirmOrderMutation($input: PlaceAffirmOrderMutationInput!) {
    checkout(input: $input)
      @rest(type: "RestPlaceAffirmOrder", endpoint: "moda", path: "/v3.5/orders", method: "POST") {
      data @type(name: "RestOrderSummary") {
        ...OrderSummaryFragment
      }
    }
  }
  ${ORDER_SUMMARY_FRAGMENT}
`;
